import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { SpinnerService } from "./core/common/SpinnerService.service";
import { delay } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  isLoading = false;
  hideSpinnerOnDashboard = false;

  /**
   * Constructor
   */
  constructor(
    private router: Router,
    public spinnerService: SpinnerService,
    private httpClient: HttpClient,
    private loader: SpinnerService
  ) {}

  ngOnInit() {
    this.listenToLoading();
    this.router.events.subscribe(() => {
    this.hideSpinnerOnDashboard = this.router.url.includes('dashboard');
  });
    //this.startRateSync();
  }

  listenToLoading(): void {
    this.spinnerService.visibility.pipe(delay(0)).subscribe((loading) => {
      this.isLoading = loading;
    });
  }
}
